import { translate } from 'components/Translation';
import { BodyS, BodySBold } from 'components/Typography/Typography';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/editUserConfirmationDialogStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IEditUserConfirmationDialogProps {
	changeUserResults: types.users.SingleChangeUserResult[];
	hideDialog: () => void;
}

const EditUserConfirmationDialog = ({ changeUserResults, hideDialog }: IEditUserConfirmationDialogProps) => {
	const classes = useStyles();

	const isDialogOpen = changeUserResults.length > 0;
	return (
		<ConfirmationDialog
			isOpen={isDialogOpen}
			hideDialog={hideDialog}
			buttons={[]}
			withIcon={false}
			header={translate('summary')}
			dialogBody={
				<div className={classes.changeUserResultsWrapper}>
					{changeUserResults.map(({ value, status }, index) => (
						<div key={index} className={classes.singleResultWrapper}>
							<BodySBold color={status === 'fulfilled' ? 'success' : 'danger'}>
								{status === 'fulfilled' ? translate('success') : translate('error')}
							</BodySBold>
							<BodyS color="secondary-light">{value}</BodyS>
						</div>
					))}
				</div>
			}
		/>
	);
};

export default EditUserConfirmationDialog;
